import { useState } from "react";

const COLORS = ["#0ea5e9", "#14b8a6", "#8b5cf6", "#f97316", "#ec4899", "#22c55e", "#eab308", "#ef4444"];
const initialsOf = (name) => (name || "?").split(" ").filter(Boolean).map((s) => s[0]).slice(0, 2).join("").toUpperCase();
const colorOf = (name) => COLORS[((name || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0)) % COLORS.length];

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const fullUrl = (u) => (u ? (u.startsWith("http") ? u : BACKEND + u) : "");

export default function Avatar({ url, name, size = 40, className = "", ring = false }) {
  const [err, setErr] = useState(false);
  const src = fullUrl(url);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.38) };
  const ringCls = ring ? "ring-2 ring-white/70 shadow" : "";
  if (src && !err) {
    return (
      <img src={src} alt={name || ""} onError={() => setErr(true)} data-testid="avatar-img"
        className={`rounded-full object-cover shrink-0 ${ringCls} ${className}`} style={style} />
    );
  }
  return (
    <div className={`rounded-full flex items-center justify-center text-white font-semibold shrink-0 ${ringCls} ${className}`}
      style={{ ...style, background: colorOf(name) }} data-testid="avatar-initials">
      {initialsOf(name)}
    </div>
  );
}
